'use client';

import Link from 'next/link';

export default function ContactPage() {
    return (
        <div className="min-h-screen bg-[#FAFAFA]">
            {/* Header */}
            <header className="bg-white border-b border-gray-200">
                <div className="max-w-4xl mx-auto px-6 py-6 flex items-center justify-between">
                    <Link href="/" className="flex items-center gap-2.5">
                        <div className="w-8 h-8 rounded-lg bg-violet-600 flex items-center justify-center">
                            <span className="text-white font-bold text-sm">W</span>
                        </div>
                        <span className="text-lg font-semibold text-gray-900">Waitlistly</span>
                    </Link>
                    <Link
                        href="/"
                        className="text-sm text-gray-500 hover:text-gray-900 transition-colors"
                    >
                        ← Back to Home
                    </Link>
                </div>
            </header>

            {/* Content */}
            <main className="max-w-4xl mx-auto px-6 py-16">
                <div className="text-center mb-12">
                    <h1 className="text-4xl font-bold text-gray-900 mb-4">Contact Us</h1>
                    <p className="text-lg text-gray-600 max-w-2xl mx-auto">
                        Have a question or need help? We&apos;d love to hear from you.
                    </p>
                </div>

                {/* Contact Card */}
                <div className="max-w-lg mx-auto">
                    <div className="bg-white border border-gray-200 rounded-2xl p-8 shadow-sm">
                        {/* Email Section */}
                        <div className="text-center">
                            <div className="w-16 h-16 rounded-2xl bg-violet-50 flex items-center justify-center mx-auto mb-6">
                                <svg className="w-8 h-8 text-violet-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                                </svg>
                            </div>
                            <h2 className="text-xl font-semibold text-gray-900 mb-2">Email Us</h2>
                            <p className="text-gray-600 mb-6">
                                For support, feedback, or general inquiries
                            </p>
                            <a
                                href="mailto:hello@waitlistly.live"
                                className="inline-flex items-center gap-2 px-6 py-3 bg-violet-600 text-white font-semibold rounded-lg hover:bg-violet-700 transition-colors"
                            >
                                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                                </svg>
                                hello@waitlistly.live
                            </a>
                        </div>

                        {/* Divider */}
                        <div className="my-8 border-t border-gray-100"></div>

                        {/* Response Time */}
                        <div className="text-center">
                            <div className="flex items-center justify-center gap-2 text-sm text-gray-500">
                                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                                </svg>
                                <span>We typically respond within 24 hours</span>
                            </div>
                        </div>
                    </div>

                    {/* Additional Info */}
                    <div className="mt-8 text-center text-sm text-gray-500">
                        <p>
                            By contacting us, you agree to our{' '}
                            <Link href="/privacy" className="text-violet-600 hover:underline">
                                Privacy Policy
                            </Link>
                        </p>
                    </div>
                </div>
            </main>

            {/* Footer */}
            <footer className="border-t border-gray-200 py-8">
                <div className="max-w-4xl mx-auto px-6 flex justify-center items-center gap-4">
                    <div className="flex items-center gap-6 text-sm text-gray-500">
                        <Link href="/terms" className="hover:text-gray-900 transition-colors">Terms of Service</Link>
                        <Link href="/privacy" className="hover:text-gray-900 transition-colors">Privacy Policy</Link>
                        <Link href="/contact" className="text-violet-600 font-medium">Contact</Link>
                    </div>
                </div>
            </footer>
        </div>
    );
}
